export default "__VITE_ASSET__COp5I_DE__"